import lodash from "lodash";
import { useSelector, useDispatch } from "react-redux";
import {
  draftBailiffAllSelector,
  draftBailiffSearchSelector,
} from "store/bailiff/draft/bailiff/draft_bailiff.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
// =========search & filter ================//
export const useDraftBailiffRefine = () => {
  // -------------------------- VAR -----------------------------
  const fields = ["name", "description"];
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(draftBailiffAllSelector);
  const search = useSelector(draftBailiffSearchSelector);
  const sorted = lodash.orderBy(data, "createAt", "desc");

  // -------------------------- FUNCTION ------------------------
  const refined = refineData(sorted, search, fields);

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return refined;
};

const refineData = (data, search, fields) => {
  let final = data || [];

  if (search !== "") {
    final = final?.filter((d) => {
      const string = combineValueSearch(fields, d);
      console.log({ string });
      const lowerName = string?.toLowerCase();
      const lowerSearch = search?.toLowerCase();
      const valids = lowerName?.includes(lowerSearch) || false;
      return valids;
    });
  }

  return final;
};

const combineValueSearch = (fields, d) => {
  let finalStr = "";

  fields?.forEach((field) => {
    const value = d[field] || null;
    if (value) {
      finalStr += `@${value}`;
    }
  });

  return finalStr;
};
